import React from 'react';
import BaseComponent from 'components/BaseComponent';
import DataTable from 'components/DataTable';
import '@/routes/Material/Util/index.less';
export class MaterialListComponent extends BaseComponent {
    state = {
    };

    render() {

        return (
            <div>
                <DataTable {...this.props} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/materialListComponent.js